﻿import { createContext, useContext as useReactContext } from 'react';

import type { FeatureFlagContextValue } from 'pages/account/feature_flag/FeatureFlagWrapper';
import { DEFAULT_TAB_CONTEXT, TabsContext, useContext } from 'components/Tabs';
import { FeatureFlag } from 'apis/FeatureFlagApi';

export type FeatureFlagData = {
	featureFlagDetails?: FeatureFlag;
}

export const FeatureFlagDetailsContext = createContext<TabsContext<FeatureFlagData>>(DEFAULT_TAB_CONTEXT);
FeatureFlagDetailsContext.displayName = 'FeatureFlagDetailsContext';

export const useFeatureFlagDetails = () => useContext(FeatureFlagDetailsContext);

export const FeatureFlagContext = createContext<FeatureFlagContextValue>({
    permissions: {
        Create: false,
        Delete: false,
        Search: false
    }
});
FeatureFlagContext.displayName = 'FeatureFlagContext';

export const useFeatureFlag = () => useReactContext(FeatureFlagContext);